import Vue from 'vue'


import App from './App'
import FastClick from 'fastclick'
import router from '@/plugins/router'
import component from '@/plugins/component'
import inject from '@/plugins/inject'
import store from '@/store'
import ToastPlugin from 'vux/src/plugins/toast/index.js'

Vue.use(ToastPlugin)

Vue.use(inject)
Vue.use(component)
Vue.config.productionTip = false


FastClick.attach(document.body)
const app = new Vue({
el: '#app',
router,
store,
components: { App },
template: '<App/>'
})
Object.getPrototypeOf(app).$setHint = function (obj) {
app.$store.commit('setHint', obj)
}


// WEBPACK FOOTER //
// ./src/main.js